import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, Icon, Button } from "semantic-ui-react";
import { useAuth } from "../../../hook/userAuth";
import { useNavigate } from "react-router-dom";
import "./Sidebarm.css";

function Sidebarm({ closeOpen, setCloseOpen }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { auth, logout } = useAuth();
  const [submenuVisible, setSubmenuVisible] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  const handleItemClick = (name) => {
    setActiveItem(name);
    setSubmenuVisible(false);
  };

  const handleLogout = () => {
    logout();
    navigate("/Login");
  };

  return (
    <div>
      {!closeOpen && (
        <Button className="openMenu" onClick={() => setCloseOpen(true)}>
          <Icon name="sidebar"></Icon>
        </Button>
      )}
      {closeOpen && (
        <Menu
          as={Menu}
          animation="overlay"
          icon="labeled"
          vertical
          width="thin"
          className="menuc"
          style={{ marginTop: "20px" }} // Ajusta el margen superior del menú principal
        >
          <Button className="closeOp" onClick={() => setCloseOpen(false)}>
            <Icon name="times"></Icon>
          </Button>

          <Menu.Item
            as={Link}
            to={"/"}
            active={pathname === "/"}
            onClick={() => handleItemClick("/")}
          >
            <Icon name="home"></Icon>Inicio
          </Menu.Item>

          {auth?.me?.es_personal_control_escolar && (
            <Menu.Item
              as={Link}
              to={"/Grupos"}
              active={
                pathname === "/Grupos" ||
                pathname === "/Grupos/AlumnosGrupo" ||
                pathname === "/Grupos/AlumnosGrupo/DatosAlumno"
              }
              onClick={() => handleItemClick("Grupos")}
            >
              <Icon name="users"></Icon>Grupos
            </Menu.Item>
          )}

          {auth?.me?.es_personal_control_escolar && (
            <Menu.Item
              name="academics"
              active={activeItem === "academics"}
              onClick={() => {
                handleItemClick("academics");
                setSubmenuVisible(!submenuVisible);
              }}
            >
              <Icon name="book" />
              Gestión académica
              {submenuVisible && activeItem === "academics" && (
                <Menu.Menu className="prio">
                  <Menu.Item
                    as={Link}
                    to="/Periodos"
                    active={pathname === "/Periodos"}
                  >
                    Ciclo escolar y períodos
                  </Menu.Item>
                  <Menu.Item
                    as={Link}
                    to={"/PlanDeEstudios"}
                    active={pathname === "/PlanDeEstudios"}
                  >
                    Plan de estudios
                  </Menu.Item>
                </Menu.Menu>
              )}
            </Menu.Item>
          )}

          {auth?.me?.es_personal_control_escolar && (
            <Menu.Item
              name="cursos"
              active={activeItem === "cursos"}
              onClick={() => {
                handleItemClick("cursos");
                setSubmenuVisible(!submenuVisible);
              }}
            >
              <Icon name="book" />
              Gestión de cursos
              {submenuVisible && activeItem === "cursos" && (
                <Menu.Menu className="prio">
                  <Menu.Item
                    as={Link}
                    to="/Materias"
                    active={pathname === "/Materias"}
                  >
                    Materias
                  </Menu.Item>
                  <Menu.Item
                    as={Link}
                    to={"/cursos"}
                    active={pathname === "/cursos"}
                  >
                    Cursos
                  </Menu.Item>
                </Menu.Menu>
              )}
            </Menu.Item>
          )}

          {auth?.me?.is_superuser && (
            <Menu.Item
              as={Link}
              to={"/gestion-administrativo"}
              active={pathname === "/gestion-administrativo"}
            >
              <Icon name="users"></Icon>Directivos
            </Menu.Item>
          )}

          {auth?.me?.is_superuser && (
            <Menu.Item
              as={Link}
              to={"/gestion-docente"}
              active={
                pathname === "/gestion-docente" ||
                pathname === "/gestion-docente/asignacion-cursos" ||
                pathname === "/gestion-docente/practicantes-disponibles/" ||
                pathname === "/gestion-docente/practicantes-asignados/"
              }
            >
              <Icon name="book"></Icon>Docentes
            </Menu.Item>
          )}
          {auth?.me?.is_superuser && (
            <Menu.Item
              as={Link}
              to={"/GestionPersonalCe"}
              active={pathname === "/GestionPersonalCe"}
            >
              <Icon name="folder"></Icon>Personal de control escolar
            </Menu.Item>
          )}
          {auth?.me?.is_superuser && (
            <Menu.Item
              as={Link}
              to={"/GestionPersonalNA"}
              active={pathname === "/GestionPersonalNA"}
            >
              <Icon name="address card outline"></Icon>Personal sin cargo
              asignado
            </Menu.Item>
          )}

          {auth?.me?.is_superuser && (
            <Menu.Item
              as={Link}
              to={"/categorias-cargos"}
              active={pathname === "/categorias-cargos"}
            >
              <Icon name="block layout"></Icon> Categorías y Cargos
            </Menu.Item>
          )}

          {auth?.me?.es_personal_control_escolar && (
            <Menu.Item
              as={Link}
              to={"/Alumnos"}
              active={pathname === "/Alumnos"}
              onClick={() => handleItemClick("Alumnos")}
            >
              <Icon name="user"></Icon>Inscripciones
            </Menu.Item>
          )}

          {auth?.me?.es_personal_control_escolar && (
            <Menu.Item
              as={Link}
              to={"/ReinscripcionAlumnos"}
              active={
                pathname === "/ReinscripcionAlumnos" ||
                pathname === "/ReinscripcionAlumnos/ListaAlumnosGrupo"
              }
              onClick={() => handleItemClick("/ReinscripcionAlumnos")}
            >
              <Icon name="retweet"></Icon>Reinscripciones
            </Menu.Item>
          )}

          {auth?.me?.es_personal_control_escolar && (
            <Menu.Item
              as={Link}
              to={"/ListaAlumnosNoIns"}
              active={
                pathname === "/ListaAlumnosNoIns" ||
                pathname === "/ListaAlumnosNoIns/DatosAlumnoNoIns"
              }
              onClick={() => handleItemClick("ListaAlumnosNoIns")}
            >
              <Icon name="user times"></Icon>Registro de bajas
            </Menu.Item>
          )}

          {auth?.me?.es_personal_control_escolar && (
            <Menu.Item
              as={Link}
              to={"/AlumnosEgresados"}
              active={
                pathname === "/AlumnosEgresados" ||
                pathname === "/AlumnosEgresados/DatosAlumnoEgresado"
              }
              onClick={() => handleItemClick("AlumnosEgresados")}
            >
              <Icon name="student"></Icon>Alumnos egresados
            </Menu.Item>
          )}

          {auth?.me?.es_personal_control_escolar && (
            <Menu.Item
              as={Link}
              to={"/boletas-alumnos"}
              active={pathname === "/boletas-alumnos"}
              onClick={() => handleItemClick("boletas-alumnos")}
            >
              <Icon name="file alternate"></Icon>Generación de Boletas
            </Menu.Item>
          )}
          {auth?.me?.es_personal_control_escolar && (
            <Menu.Item
              as={Link}
              to={"/ConstanciasAlumnos"}
              active={pathname === "/ConstanciasAlumnos"}
              onClick={() => handleItemClick("ConstanciasAlumnos")}
            >
              <Icon name="file pdf outline"></Icon>Generación de constancias
            </Menu.Item>
          )}
          {auth?.me?.es_personal_control_escolar && (
            <Menu.Item
              as={Link}
              to={"/kardex-alumnos"}
              active={pathname === "/kardex-alumnos"}
              onClick={() => handleItemClick("kardex-alumnos")}
            >
              <Icon name="clipboard outline"></Icon>Generación de Kardex
            </Menu.Item>
          )}

          {auth?.me?.es_docente && (
            <Menu.Item
              as={Link}
              to={"/mis-grupos"}
              active={
                pathname === "/mis-grupos" ||
                pathname === "/mis-grupos/CalificarAlumnosCurso"
              }
            >
              <Icon name="folder open"></Icon>Mis grupos
            </Menu.Item>
          )}
          <Menu.Item
            as={Link}
            to={"/Profile"}
            active={pathname === "/Profile"}
            onClick={() => handleItemClick("Profile")}
          >
            <Icon name="user" />
            Perfil
          </Menu.Item>

          <Menu.Item
            as={Link}
            to={"/settings"}
            active={pathname === "/settings"}
            onClick={() => handleItemClick("settings")}
          >
            <Icon name="settings" />
            Configuración de contraseña
          </Menu.Item>
          <Menu.Item onClick={handleLogout}>
            <Icon name="sign-out"></Icon>Cerrar sesión
          </Menu.Item>
        </Menu>
      )}
    </div>
  );
}
export default Sidebarm;
